import React from 'react';

export function HandsFeet() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">MANOS Y PIES</h1>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Manicura</h2>
            <div className="space-y-6">
              <div>
                <p className="font-medium">Manicura sencilla: 6€</p>
                <p className="text-gray-600 text-sm">(cortar, limar e hidratar uñas)</p>
              </div>
              <div>
                <p className="font-medium">Manicura con esmaltado: 15€</p>
                <p className="text-gray-600 text-sm">(cortar, limar, tratamiento de cutículas y esmaltado normal)</p>
              </div>
              <div>
                <p className="font-medium">Suplementos:</p>
                <ul className="text-gray-600 space-y-1 mt-2">
                  <li>• Tratamiento de cutículas: +6€</li>
                  <li>• Masaje 15 minutos: +10€</li>
                  <li>• Envoltura fría: +8€</li>
                  <li>• Parafina caliente: +12€</li>
                </ul>
              </div>
            </div>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Pedicura</h2>
            <div className="space-y-6">
              <div>
                <p className="font-medium">Pedicura sencilla: 8€</p>
                <p className="text-gray-600 text-sm">(cortar, limar e hidratar uñas)</p>
              </div>
              <div>
                <p className="font-medium">Pedicura con esmaltado: 17€</p>
                <p className="text-gray-600 text-sm">(cortar, limar, tratamiento de cutículas y esmaltado normal)</p> </div>
              <div>
                <p className="font-medium">Suplementos:</p>
                <ul className="text-gray-600 space-y-1 mt-2">
                  <li>• Tratamiento de cutículas: +6€</li>
                  <li>• Tratamiento para durezas: +8€</li>
                  <li>• Masaje 15 minutos: +10€</li>
                  <li>• Envoltura fría: +8€</li>
                  <li>• Parafina caliente: +12€</li>
                </ul>
              </div>
            </div>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}